;
define("custom_content_type_container.tpl", function(){});

